<template>
  <validation-observer ref="simpleRules">
    <b-form class="mt-1">

      <!-- Contact Status -->
      <b-form-group
        :label="$t('Contact Status')"
        label-for="mc-contact-status"
      >
        <validation-provider
          #default="{ errors }"
          :name="$t('Contact Status')"
          rules="required"
        >
          <v-select
            id="vue-select-contact-status"
            v-model="contactstatus"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionContactOptions || []"
            :placeholder="$t('Select...')"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Contact Description -->
      <b-form-group
        :label="$t('Contact Description')"
        label-for="mc-description"
      >
        <b-form-textarea
          v-model="item.contactdescription"
          :placeholder="$t('Description...')"
        />
      </b-form-group>

      <b-button
        variant="success"
        :disabled="inProgress"
        @click="validationForm"
      >
        <span v-if="!inProgress">{{ $t('Save') }}</span>
        <span v-else>{{ $t('Please wait...') }}</span>
      </b-button>

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BForm, BButton,
  BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BForm,
    BFormTextarea,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      inProgress: false,
      contactstatus: null,
      required,
      optionContactOptions: [
        'Müşteri ile görüşüldü',
        'Müşteri arandı ancak ulaşılamadı',
        'Müşteri aranmadı',
      ],
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      },
    },
  },
  watch: {
    'item.contactstatus': {
      immediate: true,
      handler() {
        this.contactstatus = this.item.contactstatus
      },
    },
  },
  async created() {
    this.contactstatus = this.item.contactstatus
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const postItem = {
            projectid: this.item.projectid,
            orjref: this.item.orjref,
            contactstatus: this.contactstatus,
            contactdescription: this.item.contactdescription,
          }
          this.inProgress = true
          useJwt.axiosIns.patch('hotAlert/contactstatus', postItem)
            .then(response2 => {
              if (response2.data) {
                // this.$emit('submit', postItem.id)
                this.$emit('refreshHotAlert')
                this.inProgress = false
              }
            })
            .catch(e => {
              this.inProgress = false
              console.log(e)
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
